module.exports = __webpack_public_path__ + "media/images/icons/map-pointer-780cd81740e8328aa61953854f1cdbf1.svg";